module.exports = __webpack_public_path__ + "static/historic-stats-c2d9d7897347d67e1f98d6a5bf1e0003.png";